/**
 * ⚠ WARNING ⚠ - This file can be used in both CLIENT AND SERVER SIDE
 */
import { Environment, getEnvironment } from "@equipmentshare/which-env";

export const getEnvPrefix = () => {
  return getEnvironment() !== Environment.PRODUCTION ? "staging-" : "";
};

export const getEnvUrl = (url: string) => {
  return `https://${getEnvPrefix()}${url}`;
};
